import { createAction } from '@ngrx/store';

export const mailboxMessageChanged = createAction('[Currently Viewing Mailbox Messages Register Hub] Mailbox Message Changed.');
